"use strict";
import "src/decidim/assemblies/assemblies";
require.context("../images", true);
